import { NodeInterface } from '@swivl-mono/types';

import TabNodeLayoutData from '../NodeLayouts/TabNodeLayoutData';
import InspectorFooter from '../SidePanel/Inspector/components/InspectorFooter';
import InspectorNodeHeader from '../SidePanel/Inspector/components/InspectorNodeHeader';
import NodePanel from './NodePanel';
import { RandomId } from '@swivl-mono/helpers';

const StoreAccessCodes = {
  Type: 'storeAccessCodes',
  Empty: function () {
    let node = {
      id: RandomId(6),
      type: StoreAccessCodes.Type,
      goto: '',
      errorGoto: '',
      notFoundGoto: '',
    };
    let data = StoreAccessCodes.PlumbData(node as NodeInterface);
    (node as any).layout = data.node.layout;
    return node;
  },
  PlumbData: function (node: NodeInterface) {
    const tabs = [
      {
        id: 'goto',
        source: 'goto',
        target: node.goto,
        title: 'Success',
      },
      {
        id: 'errorGoto',
        source: 'errorGoto',
        target: node.errorGoto,
        title: 'Error',
      },
      {
        id: 'notFoundGoto',
        source: 'notFoundGoto',
        target: node.notFoundGoto,
        title: 'Not Found',
      },
    ];
    return TabNodeLayoutData({
      node: node,
      title: 'Access Codes',
      baseWidth: 170,
      tabs: tabs,
    });
  },
  InspectorPanel: class InputInspectorPanel extends NodePanel {
    constructor(props: any) {
      super(props);
    }

    render() {
      return (
        <div>
          <div className="panel message_panel">
            <InspectorNodeHeader title="Access Codes" />
          </div>
          <InspectorFooter
            deleteNode={this.deleteNode}
            node={this.props.node}
          />
        </div>
      );
    }
  },
};

export default StoreAccessCodes;
